<template>
  <div
    v-if="showError"
    class="error-container"
  >
    {{ $t('vaApp.voiceAnalysis.error.connectionError') }}
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { ZoomSetting } from '@/api/openapi';
import { ZoomSettingApiService } from '@/api/user/resources/zoom_setting';
import ZoomSettingStatuses from '@/const/zoom_setting_statuses';

const zoomSetting = ref<ZoomSetting>(null);
const showError = computed(() => {
  if (!zoomSetting.value) return false;
  const hasApiSetting = !!zoomSetting.value.apiSetting;
  const isConnected = zoomSetting.value.apiSetting?.connectStatus === ZoomSettingStatuses.CONNECTED;
  return !hasApiSetting || !isConnected;
});

const fetchZoomSetting = async () => {
  const api = new ZoomSettingApiService();
  const { data } = await api.getZoomSetting();
  zoomSetting.value = data.zoomSetting;
};

onMounted(async () => {
  fetchZoomSetting();
});
</script>

<style lang="scss" scoped>
.error-container {
  color: $basecolor-error;
  background-color: #fff5f5;
  padding-block: $basespace-50;
  padding-inline: $basespace-100;
  text-align: center;
  width: fit-content;
  margin-inline: auto;
  margin-top: $basespace-200;
  border-radius: $basespace-50;
}
</style>
